export enum StatutDemande {
    BROUILLON = 'BROUILLON',
    TRANSMISE = 'TRANSMISE',
    EN_ATTENTE = 'EN_ATTENTE',
    A_COMPLETER = 'A_COMPLETER',
    COMPLETEE = 'COMPLETEE',
    A_VALIDER = 'A_VALIDER',
    TRANSMETTRE = 'TRANSMETTRE',
    VALIDEE = 'VALIDEE',
    REFUSEE = 'REFUSEE',
    RENVOYEE = 'RENVOYEE',
    A_ACTUALISER = 'A_ACTUALISER',
}
